export const ALL_OPEN_POSITIONS = [
  {
    id: "ai-engineer",
    title: "AI Engineer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Senior",
    desc: "Build intelligent systems that move beyond simple automation.",
    tags: ["AI/ML", "LLMs", "Python", "+2"],
    skills: [
      "Python",
      "PyTorch",
      "TensorFlow",
      "LLMs",
      "LLM",
      "RAG",
      "AI/ML",
      "Machine Learning",
      "Prompt Engineering",
      "Agents",
      "Agentic Workflows",
      "APIs",
      "Deep Learning",
      "NLP",
      "Cloud",
      "Automation",
      "Vector DB",
      "LangChain",
    ],
    featured: true,
    isNew: true,
    link: "/careers/ai-engineer",
  },
  {
    id: "senior-product-designer",
    title: "Senior Product Designer",
    dept: "Product & Design",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Senior",
    desc: "Design experiences that make complex technology feel simple.",
    tags: ["UX/UI", "Product Design", "Figma", "+2"],
    skills: [
      "Figma",
      "UI/UX",
      "UX/UI",
      "UX Design",
      "UI Design",
      "Product Design",
      "Design Systems",
      "Prototyping",
      "Wireframing",
      "User Research",
      "Interaction Design",
      "Auto-layout",
      "Component Libraries",
      "Visual Design",
    ],
    featured: true,
    isNew: true,
    link: "/careers/senior-product-designer",
  },
  {
    id: "ai-strategy-consultant",
    title: "AI Strategy Consultant",
    dept: "Strategy & Consulting",
    loc: "Multiple locations",
    workMode: "Remote",
    experience: "Lead",
    desc: "Help organizations identify where AI can create meaningful business value.",
    tags: ["Strategy", "AI", "Consulting", "+2"],
    skills: [
      "AI Strategy",
      "Consulting",
      "Strategy",
      "Digital Transformation",
      "Business Analysis",
      "Advisory",
      "ROI Modeling",
      "Enterprise Architecture",
      "Roadmaps",
      "Stakeholder Management",
      "Executive Advisory",
      "Governance",
    ],
    featured: true,
    isNew: true,
    link: "/careers/ai-strategy-consultant",
  },
  {
    id: "frontend-developer",
    title: "Frontend Developer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Level",
    desc: "Build modern, scalable, and intuitive user interfaces.",
    tags: ["React", "TypeScript", "UI/UX", "+2"],
    skills: [
      "React",
      "TypeScript",
      "JavaScript",
      "HTML",
      "CSS",
      "Tailwind CSS",
      "Tailwind",
      "Next.js",
      "Redux",
      "Frontend",
      "UI/UX",
      "Web Development",
      "WebSockets",
      "Responsive Design",
      "REST APIs",
    ],
    featured: false,
    isNew: false,
    link: "/careers/frontend-developer",
  },
  {
    id: "backend-developer",
    title: "Backend Developer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Senior",
    desc: "Design and build robust backend systems to power our AI solutions.",
    tags: ["Python", "APIs", "Cloud", "+2"],
    skills: [
      "Python",
      "FastAPI",
      "Django",
      "Node.js",
      "APIs",
      "REST",
      "Cloud",
      "AWS",
      "Docker",
      "PostgreSQL",
      "SQL",
      "Redis",
      "Microservices",
      "Backend",
      "Vector DB",
    ],
    featured: false,
    isNew: false,
    link: "/careers/backend-developer",
  },
  {
    id: "data-engineer",
    title: "Data Engineer",
    dept: "Data",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Senior",
    desc: "Build and scale data pipelines for AI-driven products.",
    tags: ["Data Pipelines", "Cloud", "SQL", "+2"],
    skills: [
      "SQL",
      "Python",
      "Data Pipelines",
      "ETL",
      "ELT",
      "Cloud",
      "AWS",
      "Snowflake",
      "Databricks",
      "Big Data",
      "Data Warehousing",
      "Data Modeling",
      "Airflow",
      "Vector Search",
    ],
    featured: false,
    isNew: true,
    link: "/careers/data-engineer",
  },
  {
    id: "product-manager",
    title: "Product Manager",
    dept: "Product & Design",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Senior",
    desc: "Define and drive product strategy from idea to impact.",
    tags: ["Product Strategy", "Roadmaps", "AI", "+2"],
    skills: [
      "Product Management",
      "Product Strategy",
      "Roadmaps",
      "AI Products",
      "Agile",
      "Scrum",
      "PRD",
      "User Stories",
      "Market Research",
      "Feature Prioritization",
      "Go-to-Market",
    ],
    featured: false,
    isNew: false,
    link: "/careers/product-manager",
  },
  {
    id: "qa-engineer",
    title: "QA Engineer",
    dept: "Technology",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Level",
    desc: "Ensure high-quality, reliable, and scalable products.",
    tags: ["Manual Testing", "Automation", "QA", "+2"],
    skills: [
      "QA",
      "Quality Assurance",
      "Manual Testing",
      "Automation Testing",
      "Selenium",
      "Cypress",
      "Playwright",
      "API Testing",
      "Test Automation",
      "Testing",
      "Regression Testing",
      "Bug Tracking",
    ],
    featured: false,
    isNew: false,
    link: "/careers/qa-engineer",
  },
  {
    id: "devops-engineer",
    title: "DevOps Engineer",
    dept: "Technology",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Mid-Senior",
    desc: "Build and maintain secure, scalable, and efficient infrastructure.",
    tags: ["AWS", "CI/CD", "Kubernetes", "+2"],
    skills: [
      "DevOps",
      "AWS",
      "Docker",
      "Kubernetes",
      "CI/CD",
      "Terraform",
      "Cloud",
      "Linux",
      "Infrastructure as Code",
      "GitHub Actions",
      "Prometheus",
      "Grafana",
      "Site Reliability",
    ],
    featured: false,
    isNew: false,
    link: "/careers/devops-engineer",
  },
  {
    id: "business-analyst",
    title: "Business Analyst",
    dept: "Strategy & Consulting",
    loc: "Multiple locations",
    workMode: "Remote",
    experience: "Mid-Level",
    desc: "Bridge business needs with technology solutions.",
    tags: ["Business Analysis", "Requirements", "AI", "+2"],
    skills: [
      "Business Analysis",
      "Requirements",
      "Requirements Gathering",
      "Process Mapping",
      "SQL",
      "Agile",
      "Stakeholder Management",
      "User Stories",
      "Analytics",
      "Documentation",
    ],
    featured: false,
    isNew: false,
    link: "/careers/business-analyst",
  },
  {
    id: "marketing-manager",
    title: "Marketing Manager",
    dept: "Marketing & Brand",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Senior",
    desc: "Drive brand growth and tell our story to the world.",
    tags: ["Brand", "Content", "Go-to-Market", "+2"],
    skills: [
      "Marketing",
      "Brand Strategy",
      "Content Marketing",
      "Go-to-Market",
      "Growth",
      "SEO",
      "Digital Marketing",
      "Social Media",
      "Product Marketing",
      "Analytics",
    ],
    featured: false,
    isNew: false,
    link: "/careers/marketing-manager",
  },
  {
    id: "people-culture-associate",
    title: "People & Culture Associate",
    dept: "People & Culture",
    loc: "Bengaluru / Hybrid",
    workMode: "Hybrid",
    experience: "Entry",
    desc: "Help us build a great place to work for everyone.",
    tags: ["HR Operations", "Talent", "Culture", "+2"],
    skills: [
      "HR",
      "Human Resources",
      "Talent Acquisition",
      "People Operations",
      "Recruiting",
      "Employee Engagement",
      "Culture",
      "Onboarding",
      "HR Operations",
      "People & Culture",
    ],
    featured: false,
    isNew: false,
    link: "/careers/people-culture-associate",
  },
];

export const ROLE_DETAILS = {
  "ai-engineer": {
    id: "ai-engineer",
    title: "AI Engineer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "2–6 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Build intelligent systems that move beyond simple automation.",
    desc: "You'll work on AI-powered systems, intelligent workflows, and technology that helps businesses solve complex problems.",
    whatYoullDo: [
      "Design and build AI-powered applications and agentic workflows",
      "Work with LLMs, agents, APIs, and enterprise systems",
      "Prototype and evaluate emerging AI capabilities",
      "Collaborate with strategy, product, and engineering teams",
      "Build solutions from experimentation through production",
    ],
    whatWereLookingFor: [
      "Strong technical skills in Python, PyTorch/TensorFlow, and modern AI libraries",
      "Experience working with LLM APIs, prompt engineering, and RAG architectures",
      "Problem-solving ability and a learning mindset",
      "Good communication and collaboration skills",
      "Curiosity about emerging technologies and a willingness to explore",
    ],
    techPills: [
      { icon: "Cpu", label: "AI / LLMs" },
      { icon: "Link2", label: "APIs" },
      { icon: "Cloud", label: "Cloud" },
      { icon: "Database", label: "Data" },
      { icon: "Zap", label: "Automation" },
      { icon: "Server", label: "Enterprise Systems" },
    ],
  },

  "senior-product-designer": {
    id: "senior-product-designer",
    title: "Senior Product Designer",
    dept: "Product & Design",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "4–8 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Design experiences that make complex technology feel simple.",
    desc: "Lead end-to-end UX/UI craft for cognitive AI systems, conversational copilots, and mission-critical enterprise workflows that users love.",
    whatYoullDo: [
      "Own end-to-end UX/UI design across our AI platform and enterprise solutions",
      "Translate complex AI and multi-agent systems into elegant, intuitive interface patterns",
      "Build, maintain, and scale our comprehensive design system and component libraries",
      "Partner closely with product managers and engineers to ship polished, pixel-perfect experiences",
      "Conduct user research, usability sessions, and interactive prototyping to validate hypotheses",
    ],
    whatWereLookingFor: [
      "4+ years of product design experience across B2B SaaS, enterprise, or high-growth tech",
      "Deep expertise in Figma, design systems, auto-layout, and interactive prototyping",
      "Strong visual craft with refined typography, color theory, and micro-interaction intuition",
      "Experience or strong curiosity regarding conversational UX and AI interaction design",
      "Strong communication skills with the ability to articulate design rationale clearly to stakeholders",
    ],
    techPills: [
      { icon: "Figma", label: "Figma" },
      { icon: "Layers", label: "Design Systems" },
      { icon: "Sparkles", label: "AI Interaction" },
      { icon: "Users", label: "UX Research" },
      { icon: "Zap", label: "Prototyping" },
      { icon: "LayoutGrid", label: "Component Libraries" },
    ],
  },

  "ai-strategy-consultant": {
    id: "ai-strategy-consultant",
    title: "AI Strategy Consultant",
    dept: "Strategy & Consulting",
    loc: "Multiple locations",
    locationDisplay: "Multiple locations · Remote",
    experience: "5–10 years (preferred)",
    workMode: "Remote",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Help organizations identify where AI can create meaningful business value.",
    desc: "Advise enterprise leaders across industries on where and how to deploy cognitive AI to unlock productivity and revenue growth.",
    whatYoullDo: [
      "Partner with enterprise C-suite executives to audit operations and pinpoint high-value AI opportunities",
      "Develop comprehensive AI transformation roadmaps, business cases, and ROI models",
      "Design target operating models, governance frameworks, and change management programs",
      "Collaborate with AI engineering architects to ensure technical feasibility and rapid deployment",
      "Publish thought leadership and industry-specific frameworks for cognitive enterprise adoption",
    ],
    whatWereLookingFor: [
      "5+ years in management consulting (top-tier firm) or strategic technology advisory",
      "Strong understanding of enterprise value chains across manufacturing, retail, or BFSI",
      "Ability to demystify complex AI/LLM concepts into crisp business imperatives for leaders",
      "Exceptional executive communication, workshop facilitation, and storytelling skills",
      "Track record of translating strategic insights into measurable operational impact",
    ],
    techPills: [
      { icon: "Compass", label: "AI Roadmaps" },
      { icon: "TrendingUp", label: "ROI Modeling" },
      { icon: "Building2", label: "Enterprise Strategy" },
      { icon: "Workflow", label: "Process Transformation" },
      { icon: "Users", label: "Executive Advisory" },
      { icon: "CheckCircle2", label: "Governance" },
    ],
  },

  "frontend-developer": {
    id: "frontend-developer",
    title: "Frontend Developer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "2–5 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Build modern, scalable, and intuitive user interfaces.",
    desc: "Create responsive, lightning-fast web applications, real-time AI interfaces, and interactive dashboards that delight enterprise users.",
    whatYoullDo: [
      "Develop high-performance, accessible web applications using React, Next.js, and TypeScript",
      "Implement real-time streaming interfaces for LLMs, agent status, and interactive data visualization",
      "Translate design specifications into clean, responsive CSS and Tailwind components with micro-animations",
      "Integrate complex REST APIs, WebSockets, and asynchronous event streams",
      "Continuously optimize Core Web Vitals, bundle size, and cross-browser rendering efficiency",
    ],
    whatWereLookingFor: [
      "Strong proficiency in modern JavaScript/TypeScript, React, HTML5, and CSS3",
      "Experience with modern frontend state management, build tooling, and component architectures",
      "Familiarity with animation libraries (Framer Motion, CSS transitions) and responsive design",
      "Deep attention to detail, UI performance, and browser rendering lifecycles",
      "Excitement about AI application UX, streaming text patterns, and clean code practices",
    ],
    techPills: [
      { icon: "Code2", label: "React / Next.js" },
      { icon: "Cpu", label: "TypeScript" },
      { icon: "Sparkles", label: "Tailwind CSS" },
      { icon: "Zap", label: "WebSockets" },
      { icon: "Link2", label: "REST APIs" },
      { icon: "Gauge", label: "Web Performance" },
    ],
  },

  "backend-developer": {
    id: "backend-developer",
    title: "Backend Developer",
    dept: "AI & Engineering",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "3–7 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Design and build robust backend systems to power our AI solutions.",
    desc: "Architect scalable microservices, resilient distributed systems, and high-throughput data APIs that power our cognitive platform.",
    whatYoullDo: [
      "Architect and scale microservices and APIs using Python (FastAPI/Django) and Node.js",
      "Build streaming APIs, webhook delivery systems, and orchestration layers for AI agents",
      "Design and maintain relational (PostgreSQL) and vector databases for semantic retrieval",
      "Build reliable enterprise integration connectors for ERPs, CRMs, and third-party tools",
      "Ensure high security, data encryption, low latency, and 99.9% uptime across all services",
    ],
    whatWereLookingFor: [
      "3+ years of backend development experience with Python, Go, or Node.js in production",
      "Deep understanding of distributed systems, async programming, and API architecture",
      "Hands-on experience with SQL databases, indexing, and vector stores (pgvector, Pinecone)",
      "Proficiency with Docker, Redis caching, message queues, and cloud infrastructure",
      "Focus on code quality, automated unit/integration testing, and system reliability",
    ],
    techPills: [
      { icon: "Server", label: "Python / FastAPI" },
      { icon: "Database", label: "PostgreSQL" },
      { icon: "Zap", label: "Redis & Queues" },
      { icon: "Cpu", label: "Vector DBs" },
      { icon: "Cloud", label: "Docker & AWS" },
      { icon: "Link2", label: "Microservices" },
    ],
  },

  "data-engineer": {
    id: "data-engineer",
    title: "Data Engineer",
    dept: "Data",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "3–6 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Build and scale data pipelines for AI-driven products.",
    desc: "Turn complex, unstructured enterprise data into high-integrity knowledge stores ready for cognitive AI reasoning.",
    whatYoullDo: [
      "Design, build, and maintain scalable batch and streaming ETL/ELT pipelines",
      "Unify disparate enterprise sources (ERPs, documents, APIs) into structured data lakes",
      "Build semantic search and vector indexing pipelines for Retrieval-Augmented Generation (RAG)",
      "Implement automated data quality verification, schema validation, and lineage tracking",
      "Optimize data warehouse query performance, storage tiering, and data governance policies",
    ],
    whatWereLookingFor: [
      "Strong software development skills in Python and SQL with deep data modeling expertise",
      "Hands-on experience with orchestration tools (Apache Airflow, Prefect, or Dagster)",
      "Experience working with cloud data warehouses (Snowflake, BigQuery, or Databricks)",
      "Familiarity with unstructured document processing (OCR, chunking, embedding generation)",
      "Passion for building reliable, fault-tolerant, self-healing data pipelines",
    ],
    techPills: [
      { icon: "Database", label: "SQL & Data Modeling" },
      { icon: "Workflow", label: "Airflow / Prefect" },
      { icon: "Cloud", label: "Snowflake / BigQuery" },
      { icon: "Cpu", label: "Vector Search" },
      { icon: "Server", label: "ETL / ELT Pipelines" },
      { icon: "ShieldCheck", label: "Data Quality" },
    ],
  },

  "product-manager": {
    id: "product-manager",
    title: "Product Manager",
    dept: "Product & Design",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "4–8 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Define and drive product strategy from idea to impact.",
    desc: "Own the vision and execution for AI-native enterprise products that transform how modern companies operate.",
    whatYoullDo: [
      "Define product vision, strategic roadmap, and feature prioritization for our AI solutions",
      "Author clear, structured PRDs and user stories in close collaboration with engineering and design",
      "Engage directly with enterprise users and executives to uncover core operational pain points",
      "Define and track product success metrics, retention, and customer ROI benchmarks",
      "Coordinate product launches and go-to-market strategies with sales and marketing teams",
    ],
    whatWereLookingFor: [
      "4+ years of product management experience in enterprise software, SaaS, or AI products",
      "Strong technical literacy to collaborate effectively with AI researchers and developers",
      "Demonstrated ability to take ambiguous customer problems and turn them into shipped solutions",
      "Data-driven analytical mindset coupled with sharp customer empathy and UX instincts",
      "Outstanding written and verbal communication skills across diverse audiences",
    ],
    techPills: [
      { icon: "Target", label: "Product Strategy" },
      { icon: "FileText", label: "PRDs & Roadmaps" },
      { icon: "Users", label: "Customer Discovery" },
      { icon: "BarChart2", label: "Product Analytics" },
      { icon: "Sparkles", label: "AI Product Craft" },
      { icon: "Zap", label: "Agile Execution" },
    ],
  },

  "qa-engineer": {
    id: "qa-engineer",
    title: "QA Engineer",
    dept: "Technology",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "2–5 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Ensure high-quality, reliable, and scalable products.",
    desc: "Champion software excellence and build automated evaluation suites for non-deterministic AI agents and enterprise systems.",
    whatYoullDo: [
      "Develop comprehensive test strategies, test cases, and quality benchmarks for AI platforms",
      "Build and maintain end-to-end automated test suites using Playwright, Cypress, or Selenium",
      "Establish evaluation harnesses to test LLM responses for consistency, accuracy, and latency",
      "Conduct rigorous API testing, edge-case evaluations, performance testing, and regression suites",
      "Integrate automated quality gates directly into CI/CD deployment pipelines",
    ],
    whatWereLookingFor: [
      "2+ years of software testing experience spanning automated and functional testing",
      "Proficiency in JavaScript/TypeScript or Python for authoring test automation frameworks",
      "Hands-on experience testing REST APIs, asynchronous webhooks, and modern web apps",
      "Inquisitive problem-solver with keen eye for subtle bugs, UX friction, and reliability regressions",
      "Familiarity with CI/CD platforms (GitHub Actions) and structured test tracking",
    ],
    techPills: [
      { icon: "CheckCircle2", label: "Playwright / Cypress" },
      { icon: "Cpu", label: "LLM Evaluation" },
      { icon: "Link2", label: "API Testing" },
      { icon: "Gauge", label: "Performance QA" },
      { icon: "Zap", label: "CI/CD Integration" },
      { icon: "ShieldCheck", label: "Regression Suites" },
    ],
  },

  "devops-engineer": {
    id: "devops-engineer",
    title: "DevOps Engineer",
    dept: "Technology",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "3–7 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Build and maintain secure, scalable, and efficient infrastructure.",
    desc: "Operate scalable cloud environments, model serving clusters, and robust CI/CD pipelines to support enterprise-grade AI applications.",
    whatYoullDo: [
      "Architect and automate cloud infrastructure across AWS and GCP using Terraform / IaC",
      "Deploy, manage, and scale production Kubernetes clusters (EKS/GKE) for high availability",
      "Configure GPU compute clusters and model serving environments with optimized inference latency",
      "Build automated, zero-downtime CI/CD deployment pipelines and GitOps workflows",
      "Implement comprehensive monitoring, alerting, and log aggregation (Prometheus, Grafana, Datadog)",
    ],
    whatWereLookingFor: [
      "3+ years of DevOps / SRE experience managing production cloud platforms (AWS or GCP)",
      "Strong hands-on experience with Kubernetes, Docker, Helm, and container security",
      "Proficiency in Infrastructure as Code (Terraform) and scripting (Bash, Python)",
      "Experience with enterprise security hardening, networking, IAM policies, and compliance",
      "Proactive mindset focused on system resilience, disaster recovery, and automated observability",
    ],
    techPills: [
      { icon: "Cloud", label: "AWS / GCP" },
      { icon: "Server", label: "Kubernetes (K8s)" },
      { icon: "Workflow", label: "Terraform (IaC)" },
      { icon: "Zap", label: "CI/CD & GitOps" },
      { icon: "Cpu", label: "GPU Clusters" },
      { icon: "Gauge", label: "Prometheus & Grafana" },
    ],
  },

  "business-analyst": {
    id: "business-analyst",
    title: "Business Analyst",
    dept: "Strategy & Consulting",
    loc: "Multiple locations",
    locationDisplay: "Multiple locations · Remote",
    experience: "2–5 years (preferred)",
    workMode: "Remote",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Bridge business needs with technology solutions.",
    desc: "Deconstruct operational workflows, extract functional requirements, and design intelligent AI-driven automation processes.",
    whatYoullDo: [
      "Analyze current-state enterprise workflows and identify operational bottlenecks and automation opportunities",
      "Translate business requirements into detailed process flows, functional specifications, and user stories",
      "Collaborate with client teams to define target KPIs, benchmark metrics, and ROI calculations",
      "Facilitate UAT testing, user onboarding, and change management for deployed AI solutions",
      "Create analytical reports, executive decks, and operational performance dashboards",
    ],
    whatWereLookingFor: [
      "2+ years of business analysis experience in consulting, enterprise IT, or B2B SaaS",
      "Proficiency in process mapping tools (BPMN, Lucidchart, Miro) and agile tooling (Jira)",
      "Strong analytical and quantitative capabilities with SQL and business intelligence tools",
      "Clear, structured communication skills with ability to lead workshops and align stakeholders",
      "Genuine curiosity about generative AI and how automation transforms enterprise productivity",
    ],
    techPills: [
      { icon: "Workflow", label: "Process Mapping" },
      { icon: "FileText", label: "Functional Specs" },
      { icon: "BarChart2", label: "SQL & Analytics" },
      { icon: "TrendingUp", label: "KPI Benchmarks" },
      { icon: "Users", label: "Stakeholder Alignment" },
      { icon: "Sparkles", label: "Workflow Automation" },
    ],
  },

  "marketing-manager": {
    id: "marketing-manager",
    title: "Marketing Manager",
    dept: "Marketing & Brand",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "4–8 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Drive brand growth and tell our story to the world.",
    desc: "Shape our global brand narrative, execute multi-channel demand generation campaigns, and establish Simpel as the leader in cognitive enterprise AI.",
    whatYoullDo: [
      "Develop and lead end-to-end B2B marketing strategies across digital, content, and events",
      "Produce high-impact customer case studies, research whitepapers, and thought leadership assets",
      "Manage inbound demand generation, SEO, and targeted LinkedIn campaigns for enterprise buyers",
      "Coordinate public relations, social media channels, event presence, and executive branding",
      "Equip the sales team with high-converting pitch collateral, competitive one-pagers, and sales decks",
    ],
    whatWereLookingFor: [
      "4+ years of B2B marketing experience within enterprise SaaS, technology, or consulting",
      "Outstanding narrative and copywriting skills with a knack for translating complex tech into clear value",
      "Proven track record of driving qualified enterprise inbound pipeline and brand authority",
      "Hands-on expertise with modern marketing automation, CRM (HubSpot), and analytics tools",
      "Creative mindset combined with data-driven accountability for pipeline and campaign metrics",
    ],
    techPills: [
      { icon: "Megaphone", label: "B2B Brand Strategy" },
      { icon: "TrendingUp", label: "Demand Generation" },
      { icon: "FileText", label: "Content & Case Studies" },
      { icon: "Globe", label: "SEO & Digital Media" },
      { icon: "Users", label: "Executive PR" },
      { icon: "BarChart2", label: "Growth Analytics" },
    ],
  },

  "people-culture-associate": {
    id: "people-culture-associate",
    title: "People & Culture Associate",
    dept: "People & Culture",
    loc: "Bengaluru / Hybrid",
    locationDisplay: "Bengaluru · Hybrid",
    experience: "1–3 years (preferred)",
    workMode: "Hybrid",
    employmentType: "Full-time",
    heroImage: "/images/careers/ai-engineer-hero.png",
    catchphrase: "Help us build a great place to work for everyone.",
    desc: "Cultivate an inclusive, vibrant team culture and champion exceptional employee experiences across every stage of the talent journey.",
    whatYoullDo: [
      "Lead smooth, memorable onboarding experiences and cultural integration for new team members",
      "Coordinate talent acquisition pipelines, candidate communications, and interview operations",
      "Design and execute team-building rituals, internal hackathons, learning sessions, and company offsites",
      "Manage HR operations, employee documentation, leave systems, and wellness programs",
      "Conduct pulse surveys, gather team feedback, and champion initiatives that keep morale high",
    ],
    whatWereLookingFor: [
      "1–3 years in People Operations, HR coordination, or recruiting within modern tech companies",
      "High emotional intelligence, genuine empathy, and warm, proactive communication skills",
      "Strong organizational abilities, confidentiality, and attention to detail",
      "Self-starter attitude with enthusiasm for taking ownership of cultural initiatives",
      "Passion for fostering an inspiring, collaborative work environment where talent thrives",
    ],
    techPills: [
      { icon: "Heart", label: "People & Culture" },
      { icon: "Users", label: "Talent Operations" },
      { icon: "Sparkles", label: "Team Experience" },
      { icon: "Calendar", label: "Culture Events" },
      { icon: "ShieldCheck", label: "HR Compliance" },
      { icon: "UserCheck", label: "Onboarding Care" },
    ],
  },
};
